import { AnimatePresence, motion } from 'framer-motion';
import type { LucideIcon } from 'lucide-react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface AccordionDesktopProps {
  icon: LucideIcon;
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}

const AccordionDesktop = ({
  icon: Icon,
  title,
  isOpen,
  onToggle,
  children,
}: AccordionDesktopProps) => {
  return (
    <div className="w-full overflow-hidden rounded-xl border border-border-subtle bg-surface-primary">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full cursor-pointer items-center justify-between px-5 py-[18px]"
      >
        <div className="flex items-center gap-3">
          <Icon className="h-5 w-5 text-accent-primary" />
          <span className="font-body text-[15px] font-semibold text-foreground-primary">
            {title}
          </span>
        </div>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2 }}
        >
          {isOpen ? (
            <ChevronUp className="h-5 w-5 text-foreground-tertiary" />
          ) : (
            <ChevronDown className="h-5 w-5 text-foreground-tertiary" />
          )}
        </motion.div>
      </button>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <div className="px-5 pb-5">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AccordionDesktop;
